import { Redirect, Route, Switch } from "react-router-dom";
import OrganisationSearch from "~/ui/OrganisationSearch";
import OrganisationDetails from "./OrganisationDetails";
import OrganisationDirectory from "./OrganisationDirectory";

export default function Organisations() {
  return (
    <Switch>
      <Route path={"/volunteering-organisations"} exact>
        <OrganisationSearch />
      </Route>
      <Route
        path={[
          "/find-organisations",
          "/*-volunteering-organisations",
          "/volunteering-organisations/in-*",
        ]}
      >
        <OrganisationSearch />
      </Route>
      <Route
        path="/volunteering-organisations/browse"
        exact
        render={({ match }) => {
          return <Redirect to={`${match.url}/a`} />;
        }}
      />
      <Route
        path="/volunteering-organisations/browse/:letter"
        component={OrganisationDirectory}
      />
      <Route
        path="/volunteering-organisations/:orgId"
        component={OrganisationDetails}
      />
    </Switch>
  );
}

export const routes = [
  "/volunteering-organisations",
  "/*-volunteering-organisations",
  "/volunteering-organisations/in-*",
  "/volunteering-organisations/browse",
  "/volunteering-organisations/browse/:letter",
  "/volunteering-organisations/:orgId",
  "/find-organisations",
];
